import layoutSVG from '@plone/volto/icons/apps.svg';
import SectionView from './components/SectionView';
import SectionEdit from './components/SectionEdit';
import { sectionSchema } from './components/schema';
import './theme/gforce.scss';

const applyConfig = (config) => {
  config.blocks.blocksConfig.gforceSection = {
    id: 'gforceSection',
    title: 'GForce section',
    icon: layoutSVG,
    group: 'common',
    view: SectionView,
    edit: SectionEdit,
    blockSchema: sectionSchema,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };
  return config;
};
export default applyConfig;
